import React, { useEffect, useState, useRef } from "react";
import { Image } from "../../../../elements/Image/Image";
import { ImageZoom } from "../../../../client/ImageZoom/ImageZoom";

export const StackedLayout = ({ settings, images }) => {
  const onImageClick = (image) => {
  };
  return (
    <div className="image-gallery-stacked">
      {images.map((image, index) => (
        <div
          key={index}
          className="image-item"
          onClick={() => onImageClick(image)}
        >
          <ImageZoom settings={settings} image={image} index={index}  />
        </div>
      ))}
    </div>
  );
};
